import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment as env} from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SiteuserService {

  constructor(private http:HttpClient) { }

  register(frmAr:any = []){
    return this.http.post(env.apiurl+'new-user-register', {
      name:frmAr.username,
      email:frmAr.useremail,
      phone:frmAr.userphone,
      password: frmAr.userpass
    }).pipe(rawData => {return rawData;});
  }

  
  siteuserRegistration(frmAr:any = []){
    return this.http.post(env.apiurl+'registersiteuser', {
      FirstName:frmAr.username,
      UserEmail:frmAr.useremail,
      UserPhone:frmAr.userphone,
      UserPassword: frmAr.userpass
    }).pipe(rawData => {return rawData;});
  }

  siteuserLogin(frmAr:any = []){
    return this.http.post(env.apiurl+'login', {
      email:frmAr.useremail,
      password: frmAr.userpass
    }).pipe(rawData => {return rawData;});
  }

  verifyRegisterOtp(otp:string,isforgot,userid='',){
    if(isforgot){
      var API_URL = 'verifyregisteration';
    }else{
      var API_URL = 'verify-new-register';
    }

    return this.http.post(env.apiurl+API_URL, {
      otp:otp,
      userid:userid
    }).pipe(rawData => {return rawData;});
  }

  addUserAddress(frmAr:any){

    return this.http.post(env.apiurl+'add-delivery-address', {
      siteuser_id:frmAr.userid,
      userName:frmAr.userName,
      phoneNumber:'+971'+frmAr.phoneNumber,
      address_one: frmAr.address_one,
      address_two:frmAr.address_two,
      apartment:frmAr.apartment,
      city:frmAr.city,
      state:frmAr.state,
      country:frmAr.country,
      lat:frmAr.lat,
      long: frmAr.long,
      usertype: frmAr.usertype ? frmAr.usertype : '',
      isDefault:1,
    }).pipe(rawData => {return rawData;});
  }

  resendOtp(email,isforgot){
    console.log(isforgot);
    if(isforgot){
      var forget = 1;
      var API_URL = 'forgetOtpMobile';
    }else{
      var forget = 0;
      var API_URL = 'resend-reg-otp';
    }
    
    return this.http.post(env.apiurl+API_URL, {
      email:email,
      forget:forget
    }).pipe(rawData => {return rawData;});
  }

  getLoggedinId(){
    return localStorage.getItem('sajid');
  }
 
  loggedIn(){
    return !!localStorage.getItem('sajtoken');
  }
  
  getToken(){
    return localStorage.getItem('sajtoken');
  }

  logout(){
    localStorage.removeItem('sajid');
    localStorage.removeItem('sajuname');
    localStorage.removeItem('sajtoken');
    localStorage.removeItem('sajuemail');
  }

  

  dateToDMY(dt){
    var date = new Date(dt);
    var d = date.getDate();
    var m = date.getMonth() + 1;
    var y = date.getFullYear();    
    return '' + (d <= 9 ? '0' + d : d) + '-' + (m<=9 ? '0' + m : m) + '-' + y;
  }

  

}
